<template>
    <picture class="c-picture--default lazyload" data-css="c-picture">
      <!--[if IE 9]><audio><![endif]-->
      <source v-set-attr="{ 'data-srcset': srcSet, 'sizes': sizes, 'srcset': srcSet }" >
      <!--[if IE 9]></audio><![endif]-->

      <img
        class="picture__image lazyload"
        :src="image.content.fallbackSrc"
        :alt="imageAlt"
		:title="imageTitle"
		v-set-attr="{'data-sizes': 'auto', 'sizes': sizes}"
      >
    </picture>
</template>

<script>
import setAttrDirecitve from "./directives/set-attr.directive";
import grabSizeFilter from "./filters/grab-size.filter";

export default {
	name: 'ListItemPicture',
	props: ['image'],
	directives: {
		setAttr: setAttrDirecitve
	},
	filters: {
		grabsize: grabSizeFilter
	},
	computed: {
		imageAlt(){
			return this.image.content.alt;
		},
		imageTitle(){
			return this.image.content.title;
		},
		srcSet(){
			return this.image.content.items[0].srcset
		},
		size(){
			const s = this.image.content.items[0].sizes;
			const d = s.split(',');
			const size = d[d.length-1];
			return size;
		},
		sizes(){
			return this.$options.filters.grabsize(this.image.content.items[0].sizes);
		}
	}
};
</script>
